import React from "react";
import PropTypes from "prop-types";

import FTSocket from "./SocketController";

export default function MessageHeader(props){
	let { socketInstance } = props
		, $dismiss = null
		, header = "Notifications"
		, numUnread = socketInstance.unread
		;

	if(numUnread){
		header = `Notifications (${numUnread})`;
		function dismissAll(e){
			e.preventDefault();
			e.stopPropagation();
			socketInstance.readAllMessages();
		}

		$dismiss = <button className="dismiss-all" type="button" onClick={dismissAll}>Dismiss All</button>;
	}

	return (
		<header className="message-header flex-center">
			<h6>{header}</h6>
			{$dismiss}
		</header>
	)	;
}

MessageHeader.displayName = "MessageHeader";
MessageHeader.propTypes = {
	socketInstance:PropTypes.instanceOf(FTSocket).isRequired,
};
